import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { IconEditSvg } from '../../../assets/icons/svgComponents'
import CheckIcon from '../../../assets/icons/svgComponents/check-icon'
import { useModalBox } from '../../../contexts'
import AlertModal from '../../alert-modal'
// import ValidadeReportForm from '../../validate-report-form'
import * as S from '../style'
import { AssessmentModel } from '../../../../domain/models/assessment'
import { ServiceModelDto } from '../../../../domain/models'

type ItemAccordionModel = {
  idCustomer: string | number
  handleOpenEditModal: any
  item: AssessmentModel
  service: ServiceModelDto
}
const ItemAssesmentCard = ({
  idCustomer,
  item,
  service
}: ItemAccordionModel) => {
  const { modalBox } = useModalBox()
  const history = useHistory()

  // const handleOpenValidateModal = (type: string) => {
  //   modalBox(
  //     <ValidadeReportForm
  //       type={type}
  //       assessment={item}
  //       idCustomer={idCustomer}
  //       service={service}
  //     />,
  //     'Validação de dados',
  //     '46%',
  //     item?.aplicacaoTeste?.realizado &&
  //       item?.entrevista?.realizado &&
  //       item?.observacaoComportamental?.realizado
  //       ? 'auto'
  //       : type === 'laudo'
  //       ? '80%'
  //       : 'auto'
  //   )
  // }

  const handleOpenPsychologicalInterviewModal = () => {
    if (item?.entrevista?.realizado === true) {
      history.push(
        `/meus-pacientes/${idCustomer}/${
          service.cdServico
        }/avaliacao-psicologica/entrevista/${
          item.cdAvaliacaoPsicologica
        }/${false}`
      )
      return
    }

    if (!item.entrevista) {
      modalBox(
        <AlertModal
          idCustomer={idCustomer}
          cdServico={item.cdAvaliacaoPsicologica}
        />,
        'Preencher entrevista',
        '32%'
      )
    } else {
      history.push(
        `/meus-pacientes/${idCustomer}/${
          service.cdServico
        }/avaliacao-psicologica/entrevista/${
          item.cdAvaliacaoPsicologica
        }/${false}`
      )
    }
  }
  return (
    <div>
      <S.TableAssesment>
        <S.ItemTableAssesment
          className="reports-link"
          onClick={() => handleOpenPsychologicalInterviewModal()}
        >
          Entrevista Psicológica
          <div className="tags-collapse">
            {item?.entrevista?.realizado && <p>Realizado</p>}
            <S.ActionButtonCardAssement>
              <IconEditSvg />
            </S.ActionButtonCardAssement>
            {/* <S.ActionButtonCard>
              <EyerSvg />
            </S.ActionButtonCard> */}
          </div>
        </S.ItemTableAssesment>
        <Link
          to={`/meus-pacientes/${idCustomer}/${service.cdServico}/avaliacao-psicologica/aplicacao-de-teste/${item.cdAvaliacaoPsicologica}`}
        >
          <S.ItemTableAssesment>
            Aplicação de Teste
            <div className="tags-collapse">
              {item?.aplicacaoTeste?.realizado && <p>Realizado</p>}
              <S.ActionButtonCardAssement>
                <IconEditSvg />
              </S.ActionButtonCardAssement>
              {/* <S.ActionButtonCardAssement>
                <EyerSvg />
              </S.ActionButtonCard> */}
            </div>
          </S.ItemTableAssesment>
        </Link>
        <Link
          to={`/meus-pacientes/${idCustomer}/${service.cdServico}/avaliacao-psicologica/observacao-comportamental/${item.cdAvaliacaoPsicologica}`}
        >
          <S.ItemTableAssesment>
            Observação Comportamental
            <div className="tags-collapse">
              {item?.observacaoComportamental?.realizado && <p>Realizado</p>}
              <S.ActionButtonCardAssement>
                <IconEditSvg />
              </S.ActionButtonCardAssement>
              {/* <S.ActionButtonCard>
                <EyerSvg />
              </S.ActionButtonCard> */}
            </div>
          </S.ItemTableAssesment>
        </Link>
      </S.TableAssesment>
      <S.SubTitle>Emitir</S.SubTitle>
      <S.ButtonEmissionList>
        <S.ButtonEmission
          to={`/meus-pacientes/${idCustomer}/${service.cdServico}/avaliacao-psicologica/laudo/${item.cdAvaliacaoPsicologica}`}
          // onClick={() =>
          //   item?.aplicacaoTeste?.realizado &&
          //   item?.observacaoComportamental?.realizado &&
          //   item?.entrevista?.realizado &&
          //   item?.todosOsDadosCompletosDoLaudo &&
          //   handleOpenValidateModal('laudo')
          // }
          disabled={false}
        >
          {item?.laudo?.realizado && (
            <div className="tags-collapse">
              <CheckIcon />
            </div>
          )}
          Laudo
        </S.ButtonEmission>

        <S.ButtonEmission
          // to={
          //   item?.todosOsDadosCompletosDoAtestado
          //     ? `/meus-pacientes/${idCustomer}/${service.cdServico}/avaliacao-psicologica/atestado/${item.cdAvaliacaoPsicologica}`
          //     : '#'
          // }
          to={`/meus-pacientes/${idCustomer}/${service.cdServico}/avaliacao-psicologica/atestado/${item.cdAvaliacaoPsicologica}`}
          // onClick={() =>
          //   !item?.todosOsDadosCompletosDoAtestado &&
          //   handleOpenValidateModal('atestado')
          // }
          disabled={false}
        >
          {item?.atestado?.realizado && (
            <div className="tags-collapse">
              <CheckIcon />
            </div>
          )}
          Atestado
        </S.ButtonEmission>

        <S.ButtonEmission
          to={`/meus-pacientes/${idCustomer}/${service.cdServico}/avaliacao-psicologica/relatorio/${item.cdAvaliacaoPsicologica}`}
          disabled={false}
        >
          {item?.relatorio?.realizado && (
            <div className="tags-collapse">
              <CheckIcon />
            </div>
          )}
          Relatório
        </S.ButtonEmission>
        <S.ButtonEmission
          disabled={false}
          to={`/meus-pacientes/${idCustomer}/${service.cdServico}/avaliacao-psicologica/parecer/${item.cdAvaliacaoPsicologica}`}
        >
          {item?.parecer?.realizado && (
            <div className="tags-collapse">
              <CheckIcon />
            </div>
          )}
          Parecer
        </S.ButtonEmission>

        <S.ButtonEmission
          disabled={false}
          // to={
          //   item?.todosOsDadosCompletosDoAtestado
          //     ? `/meus-pacientes/${idCustomer}/${service.cdServico}/avaliacao-psicologica/declaracao/${item.cdAvaliacaoPsicologica}`
          //     : '#'
          // }
          to={`/meus-pacientes/${idCustomer}/${service.cdServico}/avaliacao-psicologica/declaracao/${item.cdAvaliacaoPsicologica}`}
          // onClick={() =>
          //   !item?.todosOsDadosCompletosDoAtestado &&
          //   handleOpenValidateModal('declaração')
          // }
        >
          {item?.declaracao?.realizado && (
            <div className="tags-collapse">
              <CheckIcon />
            </div>
          )}
          Declaração
        </S.ButtonEmission>
      </S.ButtonEmissionList>
    </div>
  )
}

export default ItemAssesmentCard
